import {useMemo} from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { newGraySelectStyles } from '../../../common/shared/select.styled';
import { CurrencyValue } from '../../../common/currencyValue';
import { StyledTotalItem } from './TotalItem.styled';

/**
 * @param {string} currency
 * @param {InstallmentParams} installmentParams
 * */
export function TotalItem({ currency, total, installments, installmentParams, onInstallmentsChange = (v) => void v }) {

    const { t } = useTranslation();

    const selectorOptions = useMemo(() => (installmentParams?.options ?? []).map(o => ({
        value: o.installmentsCount,
        label: <span className={o.loaned ? 'loaned' : ''}>{o.installmentsCount}</span>,
        paymentAmountInCents: o.paymentAmountInCents,
        loanCommission: o.loanCommission,
    })), [installmentParams]);

    const loanCommission = useMemo(() => {
        const option = (installmentParams?.options ?? []).find(o => o.installmentsCount === installments);
        return option == null ? 0 : (option.loanCommission / installments)
    }, [installments, installmentParams]);

    const selectorValue = selectorOptions.find(o => o.value === installments);

    function handleInstallmentsChange(value) {
        onInstallmentsChange(value.value);
    }

    return (
        <StyledTotalItem>
            <div className='line'>
                <span className='line-name'>{t('payments.total')}</span>
                <CurrencyValue notInCents={true} currency={currency}>{total}</CurrencyValue>
            </div>
            <div className='line'>
                <span className='line-name'>{t('payments.number_of_installments')}</span>
                <Select 
                    styles={newGraySelectStyles}
                    classNamePrefix="dropdown"
                    options={selectorOptions}
                    value={selectorValue}
                    onChange={handleInstallmentsChange}
                    isSearchable={false}
                />
            </div>
            <div className='line'>
                <span className='line-name'>{t('payments.first_payment')}</span>
                {/* displaying first payment without commission requested by Rayee, see SSB-1056 */}
                <CurrencyValue currency={currency}>{selectorValue?.paymentAmountInCents - ((selectorValue?.loanCommission ?? 0) / (selectorValue?.value ?? 1))}</CurrencyValue>
            </div>
            {loanCommission > 0 && (
                <div className='line'>
                    <span className='line-name'>{t('payments.installment_cost')}</span>
                    <CurrencyValue currency={currency}>{loanCommission}</CurrencyValue>
                </div>
            )}
        </StyledTotalItem>
    )
}
